import AttachmentUrlConverter from './AttachmentUrlConverter';
import ThumbnailFarm from './ThumbnailFarm';

export const GalleryPattern = new RegExp(/\[##_Gallery\|(.*)\|([^|]*?)_##\]/mgi);
export const ImageSlidePattern = new RegExp(/\[##_ImageSlide\|([^|]+)\|([^|]*)\|([^|]*)\|([^|]*?)_##\]/mgi);

function html (images, style, attributes, caption) {
  const marks = images.map(key => '<span>&nbsp;</span>').join('');
  return `<figure contenteditable="false" data-ke-type="imageSlide" data-ke-style="${style}" data-images='${JSON.stringify(images)}'><img src="${images[0].src}" ${attributes}><div data-ke-style="mark">${marks}</div><figcaption>${caption}</figcaption></figure>`;
}

class ImageSlideConverter {
  static toHtml (content) {
    if (GalleryPattern.test(content)) {
      return content.replace(GalleryPattern, (match, keys, attributes) => {
        const images = keys.split('|')
          .filter((key, index) => index % 2 === 0)
          .map(key => ({ src: AttachmentUrlConverter.toUrl(key) }));
        return html(images, 'alignCenter', attributes, '');
      });
    }

    if (ImageSlidePattern.test(content)) {
      return content.replace(ImageSlidePattern, (match, keys, style, attributes, caption) => {
        const images = keys.split(',')
          .map(key => ({ src: AttachmentUrlConverter.toUrl(key) }));
        return html(images, style, attributes, caption);
      });
    }

    return content;
  }

  static toTistory (editor, e) {
    const { $ } = editor.dom;
    $('[data-ke-type="imageSlide"]', e.node).each((idx, elm) => {
      const $elm = $(elm);
      const keys = JSON.parse($elm.attr('data-images')).map(item => AttachmentUrlConverter.toTistory(ThumbnailFarm.from(item.src)));
      const style = $elm.attr('data-ke-style');
      const attributes = Array.prototype.slice.call($elm.find('img')[0].attributes)
        .filter(
          attr => attr.name !== 'src' &&
            attr.name.indexOf('data-mce') !== 0 &&
            attr.name.indexOf('data-ke') !== 0
        )
        .map(attr => `${attr.name}="${attr.value}"`)
        .join(' ');
      const caption = $elm.find('figcaption').text().replace('|', '');

      elm.parentNode.replaceChild(
        editor.getDoc()
          .createTextNode(`[##_ImageSlide|${keys.join(',')}|${style}|${attributes}|${caption}_##]`),
        elm
      );
    });
  }
}

export default ImageSlideConverter;
